export default __webpack_public_path__ + "static/media/PROCURE_LOGO.1f67dd48.png";